import { call, put, takeEvery } from "redux-saga/effects"

import {

  GET_USER_DEFINITIONS_BY_GUID,
  GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL,
  UPDATE_USER_DEFINITIONS_NEW_PASSWORD,
} from "./actionTypes"

import {

  getUserDefinitionByGuidSuccess,
  userDefinitionPasswordSendMailSuccess,
  updateUserDefinitionNewPasswordSuccess,
  userDefinitionNewPasswordApiError
} from "./actions"

import {
  getUserDefinitionByGuid,
  userDefinitionPasswordSendMail,
  updateUserDefinitionNewPassword,

} from "../../../helpers/backend_helper/backend_helper"

function* onGetUserDefinitionByGuid({ payload: userDefinition }) {
  try {
    const response = yield call(getUserDefinitionByGuid, userDefinition)
    yield put(getUserDefinitionByGuidSuccess(response))
  } catch (error) {

    yield put(userDefinitionNewPasswordApiError(error))
  }
}

function* onUserDefinitionPasswordSendMail({ payload: emailAdress }) { 
  try {
    const response = yield call(userDefinitionPasswordSendMail, emailAdress)
    yield put(userDefinitionPasswordSendMailSuccess(response))
  } catch (error) {

    yield put(userDefinitionNewPasswordApiError(error))
  }
}

function* onUpdateUserDefinitionNewPassword({ payload: userDefinition }) {
  try {
    const response = yield call(updateUserDefinitionNewPassword, userDefinition)
    yield put(updateUserDefinitionNewPasswordSuccess(response))
  } catch (error) {
    yield put(userDefinitionNewPasswordApiError(error))
  }
}

function* userPasswordManagementSaga() {
  yield takeEvery(GET_USER_DEFINITIONS_BY_GUID,onGetUserDefinitionByGuid)
  yield takeEvery(GET_USER_DEFINITIONS_PASSWORD_SEND_MAIL,onUserDefinitionPasswordSendMail)
  yield takeEvery(UPDATE_USER_DEFINITIONS_NEW_PASSWORD,onUpdateUserDefinitionNewPassword)
}

export default userPasswordManagementSaga